export interface IResultsOverallAPI {
  average_conversion_time_millis: number | null;
  control_group_total: number;
  control_group_total_pre_campaign: number | null;
  control_group_visited: number;
  control_group_visited_pre_campaign: number | null;
  conversion_time_distribution: Record<string, number> | null;
  created_on_utc: string;
  exposed_to_ad_group_total: number;
  exposed_to_ad_group_total_pre_campaign: number | null;
  exposed_to_ad_group_visited: number;
  exposed_to_ad_group_visited_pre_campaign: number | null;
  id: number;
  liftanalysis_id: number;
  modified_on_utc: string;
  swarm_aws_region: string;
  visits_per_weekday: {
    monday: number;
    tuesday: number;
    wednesday: number;
    thursday: number;
    friday: number;
    saturday: number;
    sunday: number;
  } | null;
}

interface VisitsPerWeekday {
  monday: number;
  tuesday: number;
  wednesday: number;
  thursday: number;
  friday: number;
  saturday: number;
  sunday: number;
}

export default class ResultsOverall {
  averageConversionTimeMillis: number | null;

  controlGroupTotal: number;

  controlGroupTotalPreCampaign: number | null;

  controlGroupVisited: number;

  controlGroupVisitedPreCampaign: number | null;

  conversionTimeDistribution: Record<string, number> | null;

  createdOnUtc: string;

  exposedToAdGroupTotal: number;

  exposedToAdGroupTotalPreCampaign: number | null;

  exposedToAdGroupVisited: number;

  exposedToAdGroupVisitedPreCampaign: number | null;

  id: number;

  liftAnalysisId: number;

  modifiedOnUtc: string;

  swarmAwsRegion: string;

  visitsPerWeekday: VisitsPerWeekday | null;

  constructor(
    averageConversionTimeMillis: number | null,
    controlGroupTotal: number,
    controlGroupTotalPreCampaign: number,
    controlGroupVisited: number,
    controlGroupVisitedPreCampaign: number | null,
    conversionTimeDistribution: Record<string, number> | null,
    createdOnUtc: string,
    exposedToAdGroupTotal: number,
    exposedToAdGroupTotalPreCampaign: number | null,
    exposedToAdGroupVisited: number,
    exposedToAdGroupVisitedPreCampaign: number | null,
    id = -1,
    liftAnalysisId: number,
    modifiedOnUtc: string,
    swarmAwsRegion: string,
    visitsPerWeekday: VisitsPerWeekday | null,
  ) {
    this.averageConversionTimeMillis = averageConversionTimeMillis;
    this.controlGroupTotal = controlGroupTotal;
    this.controlGroupTotalPreCampaign = controlGroupTotalPreCampaign;
    this.controlGroupVisited = controlGroupVisited;
    this.controlGroupVisitedPreCampaign = controlGroupVisitedPreCampaign;
    this.conversionTimeDistribution = conversionTimeDistribution;
    this.createdOnUtc = createdOnUtc;
    this.exposedToAdGroupTotal = exposedToAdGroupTotal;
    this.exposedToAdGroupTotalPreCampaign = exposedToAdGroupTotalPreCampaign;
    this.exposedToAdGroupVisited = exposedToAdGroupVisited;
    this.exposedToAdGroupVisitedPreCampaign = exposedToAdGroupVisitedPreCampaign;
    this.id = id;
    this.liftAnalysisId = liftAnalysisId;
    this.modifiedOnUtc = modifiedOnUtc;
    this.swarmAwsRegion = swarmAwsRegion;
    this.visitsPerWeekday = visitsPerWeekday;
  }

  static fromApi(apiObject: IResultsOverallAPI): ResultsOverall {
    return new ResultsOverall(
      apiObject.average_conversion_time_millis,
      apiObject.control_group_total,
      apiObject.control_group_total_pre_campaign,
      apiObject.control_group_visited,
      apiObject.control_group_visited_pre_campaign,
      apiObject.conversion_time_distribution,
      apiObject.created_on_utc,
      apiObject.exposed_to_ad_group_total,
      apiObject.exposed_to_ad_group_total_pre_campaign,
      apiObject.exposed_to_ad_group_visited,
      apiObject.exposed_to_ad_group_visited_pre_campaign,
      apiObject.id,
      apiObject.liftanalysis_id,
      apiObject.modified_on_utc,
      apiObject.swarm_aws_region,
      apiObject.visits_per_weekday,
    );
  }

  toApi() {
    return {
      average_conversion_time_millis: this.averageConversionTimeMillis,
      control_group_total: this.controlGroupTotal,
      control_group_total_pre_campaign: this.controlGroupTotalPreCampaign,
      control_group_visited: this.controlGroupVisited,
      control_group_visited_pre_campaign: this.controlGroupVisitedPreCampaign,
      conversion_time_distribution: this.conversionTimeDistribution,
      created_on_utc: this.createdOnUtc,
      exposed_to_ad_group_total: this.exposedToAdGroupTotal,
      exposed_to_ad_group_total_pre_campaign: this.exposedToAdGroupTotalPreCampaign,
      exposed_to_ad_group_visited: this.exposedToAdGroupVisited,
      exposed_to_ad_group_visited_pre_campaign: this.exposedToAdGroupVisitedPreCampaign,
      id: this.id,
      liftanalysis_id: this.liftAnalysisId,
      modified_on_utc: this.modifiedOnUtc,
      swarm_aws_region: this.swarmAwsRegion,
      visits_per_weekday: this.visitsPerWeekday,
    };
  }
}
